import { RulebookStyle } from '../../../../shared/enums/RulebookEnums.ts';
import { RUSH_RULES_YOUTUBE_VIDEO_URL } from '@colonist/consts';
import { StorageWrapper } from '../StorageWrapper.ts';
import { UIUrlParameterNames } from '../ui_html/UIUrlController.ts';
import { UIScrollController } from '../ui_scroll_controller/UIScrollController.ts';
import { getHomepageUrl, navigateToPage } from '../ui_utils/ClientUtils.ts';
import { setElementOnClick } from '../ui_utils/DomUtils.ts';
import { UIEntryUrlParameterController } from '../UIEntryUrlParameterController.ts';
import { UIMSceneEnum } from '../../../../shared/enums/UIMSceneEnums.ts';
export class UIRulebookController extends UIScrollController {
    updateNavigationVisibility(scrollElement) {
        if (this.navigationWrapper == null) return;
        const scrollTop = scrollElement.scrollTop;
        const scrollDelta = scrollTop - this.lastScrollTop;
        if (Math.abs(scrollDelta) < UIRulebookController.SCROLL_DELTA_THRESHOLD) return;
        const isScrollingDown = scrollDelta > 0;
        this.navigationWrapper.classList.toggle(UIRulebookController.NAVIGATION_HIDDEN_CLASS, isScrollingDown);
        this.lastScrollTop = scrollTop;
    }
    static setupRushVideoPlaceholderListener() {
        const placeholder = document.getElementById('rulebook-rush-video-placeholder');
        if (placeholder == null) return;
        setElementOnClick(placeholder, ()=>UIRulebookController.openRushVideo());
    }
    static openRushVideo() {
        // On Discord the rulebook runs in a sandboxed nested iframe where window.open is blocked,
        // so delegate to the same-origin content frame whose window.open routes through the Discord SDK.
        window.parent.open(RUSH_RULES_YOUTUBE_VIDEO_URL, '_blank');
    }
    static setupBackButtonListener() {
        const backButton = document.getElementById('rulebook-header-back-button');
        if (backButton == undefined) return;
        setElementOnClick(backButton, ()=>UIRulebookController.goBack());
    }
    static setupLogoButtonListener() {
        const logoButton = document.getElementById('rulebook-header-logo-button');
        if (logoButton == undefined) return;
        setElementOnClick(logoButton, ()=>UIRulebookController.goBack());
    }
    static goBack() {
        const url = UIRulebookController.getRulebookHomepageUrl();
        StorageWrapper.clearLastScene();
        navigateToPage(url);
    }
    setupLinkListener() {
        // eslint-disable-next-line no-restricted-syntax
        document.body.addEventListener('click', (e)=>{
            if (e.target == null) return;
            const link = e.target;
            const closestNavigationSectionLink = link.closest('a');
            const isSectionLink = closestNavigationSectionLink === null || closestNavigationSectionLink === void 0 ? void 0 : closestNavigationSectionLink.href.includes('#');
            if (!isSectionLink) return;
            if (closestNavigationSectionLink !== null) this.onSidebarClick(e);
        });
    }
    static setRulebookLinksStyle() {
        if (UIRulebookController.rulebookStyle == null) return;
        document.querySelectorAll('a').forEach((link)=>{
            const isInternalLink = link.href.startsWith(location.origin);
            if (!isInternalLink) return;
            const isSamePage = link.pathname === location.pathname;
            if (isSamePage) return;
            const url = new URL(link.href);
            url.searchParams.set('style', UIRulebookController.rulebookStyle);
            link.href = url.toString();
        });
    }
    static getRulebookHomepageUrl() {
        if (UIRulebookController.rulebookStyle != RulebookStyle.Mobile) return getHomepageUrl();
        const lastScene = StorageWrapper.getLastScene();
        if (lastScene == null) return getHomepageUrl();
        const mobileSceneParameter = UIRulebookController.getMobileSceneParameter(lastScene);
        return `${getHomepageUrl()}#${mobileSceneParameter}=${UIEntryUrlParameterController.DEFAULT_PARAMETER_VALUE}`;
    }
    static getMobileSceneParameter(scene) {
        switch(scene){
            case UIMSceneEnum.Leaderboard:
                return UIUrlParameterNames.MobileLeaderboard;
            case UIMSceneEnum.Lobby:
                return UIUrlParameterNames.MobileLobby;
            case UIMSceneEnum.Store:
                return UIUrlParameterNames.MobileStore;
            case UIMSceneEnum.More:
                return UIUrlParameterNames.MobileMore;
            default:
                return UIUrlParameterNames.MobileHomepage;
        }
    }
    constructor(){
        const urlParams = new URLSearchParams(window.location.search);
        var _urlParams_get;
        UIRulebookController.rulebookStyle = (_urlParams_get = urlParams.get('style')) !== null && _urlParams_get !== void 0 ? _urlParams_get : null;
        UIRulebookController.setupBackButtonListener();
        UIRulebookController.setupLogoButtonListener();
        const rulebookContentElement = document.getElementById('rulebook-content');
        const rulebookContentContainer = rulebookContentElement.getElementsByClassName('rulebook-content-container')[0];
        const rulebookSideNavigationElement = document.getElementById('rulebook-side-navigation');
        super(rulebookContentContainer, rulebookSideNavigationElement, rulebookContentElement, 'side-navigation-link-current-section'), this.navigationWrapper = document.getElementById('rulebook-top-navigation-wrapper'), this.lastScrollTop = 0;
        rulebookContentElement.addEventListener('scroll', ()=>{
            this.onContentScroll();
            this.updateNavigationVisibility(rulebookContentElement);
        });
        this.setupLinkListener();
        UIRulebookController.setRulebookLinksStyle();
        UIRulebookController.setupRushVideoPlaceholderListener();
    }
}
UIRulebookController.NAVIGATION_HIDDEN_CLASS = 'rulebook-top-navigation-hidden';
UIRulebookController.SCROLL_DELTA_THRESHOLD = 8;
